import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { space, SpaceProp } from 'components/layout/primitives/utils'

interface Props {
	columnWidth?: number
	fillDirection?: 'column' | 'row'
	fillMax?: number
}

// Create as many columns as will fit such that they are between columnWidth and the full width
const setColumnWidth = ({ columnWidth = 250 }: Props) => css`
	grid-template-columns: repeat(auto-fit, minmax(min(${columnWidth}px, 100%), 1fr));
`

// If filling columns first, create fillMax rows, fill them before moving to the next column.
// If we run out of template rows and columns, add items in auto new rows
const fillColumnsIfDirection = ({ fillDirection = 'row', fillMax = 3 }: Props) =>
	fillDirection === 'column' &&
	css`
		grid-template-rows: repeat(${fillMax}, 1fr);
		grid-auto-columns: 0;
		grid-auto-rows: auto;
		grid-auto-flow: column;
	`

/**
 * Lays out children in a grid of equal width columns whose width is the largest child, separated by a gap. Children are placed in the grid without stretching to fill empty cells.
 * Inspired by https://every-layout.dev/layouts/grid/
 *
 * Similar primitives include Cluster and Switcher
 *
 * @param space - An override to change the gap between cells, defaults to base
 */
export const Grid = styled.div<Props & SpaceProp>`
	display: grid;
	grid-gap: ${space};
	@supports (width: min(250px, 100%)) {
		${setColumnWidth}
		${fillColumnsIfDirection};
	}
`
